import { SET_TOKEN } from '../../actions/ossif-auth/setToken'

const initialState = {
  token: null
}

export default function TokenReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOKEN:
      console.log(action.payload)
      return {
        ...state,
        token: action.payload
      }
    default:
      return state
  }
}
